(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller(
      "VirtualFairExhibitorRepresentativeController",
      VirtualFairExhibitorRepresentativeController
    );
  VirtualFairExhibitorRepresentativeController.$inject = [
    "VirtualFairService",
    "$timeout",
    "virtualFairs",
    "isPlatformRental"
  ];

  function VirtualFairExhibitorRepresentativeController(
    VirtualFairService,
    $timeout,
    virtualFairs,
    isPlatformRental
  ) {
    var vm = this;
    vm.getVirtualFairs = getVirtualFairs;
    vm.getByFilter = getByFilter;
    vm.queryFlag = false;
    vm.virtualFairSelected = "";
    vm.search = "";
    vm.sendCredentials = sendCredentials;
    vm.sendCredential = sendCredential;
    vm.downloadCSV = downloadCSV;
    vm.isPlatformRental = isPlatformRental;

    /* PAGINATION */
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.page = 1;

    function setPage(page) {
      vm.currentPage = page;
    }

    function pageChanged(page) {
      vm.page = vm.currentPage;
      vm.getByFilter(false);
    }

    function getVirtualFairs() {
      if(virtualFairs) {
        vm.virtualFairs = virtualFairs;
      } else {
        vm.query = {};
        VirtualFairService.getAll(vm.query).then(function (response) {
          vm.virtualFairs = response.data;
        });
      }
    }

    function getByFilter() {
      vm.queryFlag = false;
      vm.query = {};
      vm.query["page"] = vm.page;
      if(vm.isPlatformRental) {
        vm.query['platform-rental'] = 1;
      }
      if (vm.virtualFairSelected) {
        vm.query["virtual_fair_id"] = vm.virtualFairSelected;
      }
      if (vm.search) {
        vm.query["search"] = vm.search;
      }
      VirtualFairService.representatives(vm.query).then(function (response) {
        vm.queryFlag = true;
        vm.representatives = response.data.data;
        vm.to = response.data.to;
        vm.totalItems = response.data.total;
        vm.itemsPerPage = response.data.per_page;
        vm.setPage(response.data.current_page);
      });
    }

    function downloadCSV() {
      vm.query = {};
      if(vm.isPlatformRental) {
        vm.query['platform-rental'] = 1;
      }
      if (vm.virtualFairSelected) {
        vm.query["virtual_fair_id"] = vm.virtualFairSelected;
      }
      if (vm.search) {
        vm.query["search"] = vm.search;
      }
      VirtualFairService.representativesCSV(vm.query).success(function (
        data,
        status,
        headers,
        config
      ) {
        var anchor = document.createElement("a");
        anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
        anchor.target = "_blank";
        anchor.download = `virtual_fair_exhibitors_representatives_${vm.virtualFairSelected}.csv`;
        document.body.appendChild(anchor);
        anchor.click();
        $timeout(function () {
          anchor.remove();
        }, 50);
      });
    }

    function active() {
      vm.getVirtualFairs();
    }

    function sendCredentials() {
      vm.query = {};
      vm.query["representatives"] = vm.representatives;
      vm.query["virtual_fair_id"] = vm.virtualFairSelected;
      VirtualFairService.sendCredentials(vm.query).then(function (response) {
        alertify.notify("Credentials successfully sended", "success", 3);
        vm.getByFilter();
      });
    }

    function sendCredential(id) {
      vm.query = {};
      vm.query["representative"] = id;
      VirtualFairService.sendCredential(vm.query).then(function (response) {
        alertify.notify("Credentials successfully sended", "success", 3);
        vm.getByFilter();
      });
    }
    active();
  }
})();
